module.exports = __webpack_public_path__ + "media/images/ui__arrowUp--dark-8c3b91529e0c78c4cf00761794b4befe.png";